export const LS_FORM_USER_DATA_KEY = "marketo_returning_user";
export const LS_IS_SIGNED_UP_KEY = "marketo_is_signed_up";
